<footer class="footer">
    <div class="d-sm-flex justify-content-center">
        <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © {{currentYear}} Lungisa All Rights Reserved.</span>
        <!-- <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">sample  <a href="https://www.bootstrapdash.com/angular-admin-templates/" target="_blank"> Admin Pnel </a></span> -->
    </div>
</footer>
